module.exports = {
    sectionSubtitle: (type = "", value = "") => `
    <div class="section-subtitle-container">
        <p class="section-subtitle section-subtitle-${type}">${value}</p>
    </div>
    `
}
